import { Dialog } from "react-native-paper";
import DialogWrapper from "../DialogWrapper";
import PdfRenderer from "../StudySession/PdfRenderer";

const DEFAULT_SOURCE = {
	uri: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/jbjs-assets/pdfs/chapman.pdf",
	cache: true,
};

type Props = {
	pageNumber: number | null;
	visible: boolean;
	handleClose: () => void;
	source?: { uri: string; cache?: boolean };
};

const CitationSourceDialog = ({
	pageNumber,
	visible,
	handleClose,
	source = DEFAULT_SOURCE,
}: Props) => {
	return (
		<DialogWrapper
			visible={visible}
			handleClose={handleClose}
			maxWidth="md"
			height="80%"
		>
			<Dialog.Title>Citation Source</Dialog.Title>
			<Dialog.Content
				style={{
					flex: 1,
					paddingHorizontal: 8,
					paddingBottom: 8,
				}}
			>
				{pageNumber && <PdfRenderer pageNumber={pageNumber} source={source} />}
			</Dialog.Content>
		</DialogWrapper>
	);
};

export default CitationSourceDialog;
